import React from 'react'
export default function Apptoplogo({img}) {
  return (
    <div className='apptoplogo'>
        <img src={img} alt="" />
    </div>
  )
}
